
import React, { useState } from "react";
import "./GoogleBusinessPage.css";
import GoogleBusinessCard from "../../assets/Images/GoogleBusinessPage/google-business-profile.png";
import VisibilityIcon from "../../assets/Images/GoogleBusinessPage/visibility-icon.svg";
import TrustIcon from "../../assets/Images/GoogleBusinessPage/trust-icon.svg";
import CustomersIcon from "../../assets/Images/GoogleBusinessPage/customers-icon.svg";
import StarIcon from "../../assets/Images/GoogleBusinessPage/star1.svg";
import TrafficIcon from "../../assets/Images/GoogleBusinessPage/traffic-icon.svg";
import EyeIcon from "../../assets/Images/GoogleBusinessPage/eye-icon.svg";
import CallIcon from "../../assets/Images/GoogleBusinessPage/call-icon.svg";
import collab from "../../assets/Images/GoogleBusinessPage/collab.svg";

import LocationIcon from "../../assets/Images/GoogleBusinessPage/location.svg";
import CalendarIcon from "../../assets/Images/GoogleBusinessPage/calendar-icon.svg";
import StarIcon1 from "../../assets/Images/GoogleBusinessPage/star-icon.svg";
import TagIcon from "../../assets/Images/GoogleBusinessPage/tag-icon.svg";
import ChartIcon from "../../assets/Images/GoogleBusinessPage/chart-icon.svg";
import GlobeIcon from "../../assets/Images/GoogleBusinessPage/globe-icon.svg";

import Header from "../../assets/components/01_header/header";
import Footer from "../../assets/components/02_footer/footer";

const GoogleBusinessProfile = () => {
  return (
    <section className="GoogleBusinessProfile-Section">

      {/* LEFT CONTENT */}
      <div className="GoogleBusinessProfile-Content">

        <p className="GoogleBusinessProfile-Subtitle">
          GOOGLE BUSINESS PROFILE
        </p>

        <h2 className="GoogleBusinessProfile-Heading">
          Be Found. Get Chosen.
          <br />
          Grow Faster
        </h2>

        <p className="GoogleBusinessProfile-Description">
          We manage your Google Business Profile so you get more visibility,
          <br />
          more reviews and more customers.
        </p>

        <div className="GoogleBusinessProfile-Features">

  <div className="GoogleBusinessProfile-Feature">
    <img
      src={VisibilityIcon}
      alt=""
      className="GoogleBusinessProfile-Feature-Icon"
    />
    <span>More Visibility</span>
  </div>

  <div className="GoogleBusinessProfile-Feature">
    <img
      src={TrustIcon}
      alt=""
      className="GoogleBusinessProfile-Feature-Icon"
    />
    <span>More Trust</span>
  </div>

  <div className="GoogleBusinessProfile-Feature">
    <img
      src={CustomersIcon}
      alt=""
      className="GoogleBusinessProfile-Feature-Icon"
    />
    <span>More Customers</span>
  </div>

</div>
      </div>

     {/* RIGHT VISUAL */}

<div className="GoogleBusinessProfile-Visual">

  <img
    src={GoogleBusinessCard}
    alt="Google Business Profile preview"
    className="GoogleBusinessProfile-Card-Image"
  />

</div>

    </section>
  );
};



const GoogleBusinessPricing = () => {
  const [profiles, setProfiles] = useState(3);

  const discount =
    profiles >= 6 ? 30 : profiles >= 3 ? 20 : 0;

  const pricePerProfile =
    profiles >= 6 ? 3499 : profiles >= 3 ? 3999 : 4999;

  const totalPrice = profiles * pricePerProfile;

  const formatPrice = (price) =>
    new Intl.NumberFormat("en-IN", {
      maximumFractionDigits: 0,
    }).format(price);

  const handleConsultation = () => {
    // Replace this with your consultation/contact action.
    window.location.href = "/contact";
  };

  return (
    <section className="GoogleBusinessPricing-Section">

      {/* LEFT SIDE: PRICING CALCULATOR */}
      <div className="GoogleBusinessPricing-Left">

        <p className="GoogleBusinessPricing-Subtitle">
          CHOOSE YOUR PLAN
        </p>

        <h2 className="GoogleBusinessPricing-Heading">
          Flexible Pricing for
          <br />
          Every Business.
        </h2>

        <p className="GoogleBusinessPricing-Description">
          The more profiles we manage, the more you save
        </p>

        {/* DISCOUNT LABELS */}
        <div className="GoogleBusinessPricing-DiscountLabels">
          <span className="GoogleBusinessPricing-DiscountLabel DiscountLabel-First">
            0% OFF
          </span>

          <span className="GoogleBusinessPricing-DiscountLabel DiscountLabel-Second">
            20% OFF
          </span>

          <span className="GoogleBusinessPricing-DiscountLabel DiscountLabel-Third">
            30% OFF
          </span>
        </div>

        
{/* SLIDER */}
<div className="GoogleBusinessPricing-SliderContainer">
  <input
    type="range"
    min="1"
    max="20"
    step="1"
    value={profiles}
    onChange={(event) =>
      setProfiles(Number(event.target.value))
    }
    className="GoogleBusinessPricing-Slider"
    style={{
      "--slider-progress": `${((profiles - 1) / 19) * 100}%`,
    }}
    aria-label="Number of profiles"
  />

  <div className="GoogleBusinessPricing-SliderMarks">
    <span>1</span>
    <span>3</span>
    <span>6</span>
    <span>20+</span>
  </div>
</div>


        {/* PRICE SUMMARY */}
        <div className="GoogleBusinessPricing-Summary">

          <div className="GoogleBusinessPricing-Summary-Left">
            <p className="GoogleBusinessPricing-SelectedProfiles">
              {profiles} {profiles === 1 ? "profile" : "profiles"}
            </p>

            <p className="GoogleBusinessPricing-Discount">
              {discount}% OFF
            </p>
          </div>

          <div className="GoogleBusinessPricing-Summary-Right">
            <p className="GoogleBusinessPricing-TotalLabel">
              Total Value
            </p>

            <div className="GoogleBusinessPricing-TotalPrice">
              <strong>₹{formatPrice(totalPrice)}</strong>
              <span>/ 28 days</span>
            </div>
          </div>

        </div>

        {/* CTA BUTTON */}
        <button
          type="button"
          className="GoogleBusinessPricing-ConsultationButton"
          onClick={handleConsultation}
        >
          BOOK YOUR FREE CONSULTATION
        </button>

      </div>

      {/* VERTICAL DIVIDER */}
      <div className="GoogleBusinessPricing-Divider"></div>

      {/* RIGHT SIDE: WHAT'S INCLUDED */}
      <div className="GoogleBusinessPricing-Right">

        <p className="GoogleBusinessPricing-IncludedSubtitle">
          WHAT'S INCLUDED
        </p>

        <h2 className="GoogleBusinessPricing-IncludedHeading">
          Everything You Need
          <br />
          to Grow
        </h2>

          
<div className="GoogleBusinessPricing-IncludedList">
  <div className="GoogleBusinessPricing-IncludedItem">
    <img
      className="GoogleBusinessPricing-IncludedIcon"
      src={LocationIcon}
      alt=""
    />
    <span>Google Business Profile Management</span>
  </div>

  <div className="GoogleBusinessPricing-IncludedItem">
    <img
      className="GoogleBusinessPricing-IncludedIcon"
      src={CalendarIcon}
      alt=""
    />
    <span>1 Weekly post per account</span>
  </div>

  <div className="GoogleBusinessPricing-IncludedItem">
    <img
      className="GoogleBusinessPricing-IncludedIcon"
      src={StarIcon1}
      alt=""
    />
    <span>Review management</span>
  </div>

  <div className="GoogleBusinessPricing-IncludedItem">
    <img
      className="GoogleBusinessPricing-IncludedIcon"
      src={TagIcon}
      alt=""
    />
    <span>Products/services updates</span>
  </div>

  <div className="GoogleBusinessPricing-IncludedItem">
    <img
      className="GoogleBusinessPricing-IncludedIcon"
      src={TrafficIcon}
      alt=""
    />
    <span>Monthly report</span>
  </div>

  <div className="GoogleBusinessPricing-IncludedItem">
    <img
      className="GoogleBusinessPricing-IncludedIcon"
      src={GlobeIcon}
      alt=""
    />
    <span>Basic single-page website</span>
  </div>
</div>
</div>

    </section>
  );
};


const GoogleBusinessWhyItWorks = () => {
  const features = [
    {
      id: 1,
      title: "Get Found Locally",
      description: "Show up when people search for your services.",
      color: "Visibility",
      icon: EyeIcon,
    },
    {
      id: 2,
      title: "Build Trust",
      description: "Real reviews create confidence and credibility.",
      color: "Trust",
      icon: StarIcon,
    },
    {
      id: 3,
      title: "Drive More Calls",
      description: "Make it easy for customers to contact you",
      color: "Calls",
      icon : CallIcon,
    },
    {
      id: 4,
      title: "Increase Website Traffic",
      description: "Turn profile visitors into website visitors.",
      color: "Traffic",
      icon : TrafficIcon,
    },
    {
      id: 5,
      title: "Stay Ahead",
      description: "Be visible, be relevant, be chosen.",
      color: "Ahead",
      icon : collab,
    },
  ];

  const handleConsultation = () => {
    window.location.href = "/contact";
  };

  return (
    <section className="GoogleBusinessWhyItWorks-Section">
      <div className="GoogleBusinessWhyItWorks-Container">

        {/* HEADER */}
        <div className="GoogleBusinessWhyItWorks-Header">
          <p className="GoogleBusinessWhyItWorks-Subtitle">
            WHY IT WORKS
          </p>

          <h2 className="GoogleBusinessWhyItWorks-Heading">
            A Google Business Profile
            <br className="GoogleBusinessWhyItWorks-DesktopBreak" />
            Brings Real Results
          </h2>

          <p className="GoogleBusinessWhyItWorks-Description">
            More Visibility. More Trust. More Customers
          </p>
        </div>

        {/* FEATURES */}
        <div className="GoogleBusinessWhyItWorks-Features">
          {features.map((feature) => (
            <div
              className="GoogleBusinessWhyItWorks-Feature"
              key={feature.id}
            >
              <div
                className={`GoogleBusinessWhyItWorks-IconContainer GoogleBusinessWhyItWorks-IconContainer-${feature.color}`}
              >
                <img
  className="GoogleBusinessWhyItWorks-Icon"
  src={feature.icon}
  alt=""
/>
              </div>

              <h3 className="GoogleBusinessWhyItWorks-FeatureTitle">
                {feature.title}
              </h3>

              <p className="GoogleBusinessWhyItWorks-FeatureDescription">
                {feature.description}
              </p>
            </div>
          ))}
        </div>

        {/* CTA BUTTON */}
        <div className="GoogleBusinessWhyItWorks-ButtonWrapper">
          <button
            type="button"
            className="GoogleBusinessWhyItWorks-Button"
            onClick={handleConsultation}
          >
            BOOK YOUR FREE CONSULTATION
          </button>
        </div>

      </div>
    </section>
  );
};


function GoogleBusinessPage() {
  return (
    <main>
      <Header />
        <GoogleBusinessProfile />
        <GoogleBusinessPricing />
        <GoogleBusinessWhyItWorks />
      <Footer />
    </main>
  );
};





export default GoogleBusinessPage;